import ManagePayrollPage from './ManagePayroll';

// Payroll page wrapper
export default function Payroll() {
  return <ManagePayrollPage />;
}